import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';


const mockActivities = [
  { id: 1, client: 'John C.', action: 'finished', detail: 'Leg Day', status: 'active', time: '2m ago' },
  { id: 2, client: 'Maria V.', action: 'logged', detail: '10,000 steps', status: 'active', time: '5m ago' },
  { id: 3, client: 'Kevin L.', action: 'plan needs', detail: 'adjustment', status: 'overdue', time: '12m ago' },
  { id: 4, client: 'Sara M.', action: 'completed', detail: 'Upper Body', status: 'active', time: '18m ago' },
  { id: 5, client: 'Tom R.', action: 'missed', detail: 'Cardio Session', status: 'overdue', time: '1h ago' },
];

const StatusDot = ({ status }) => {
  if (status === 'active') {
    return (
      <span style={{ position: 'relative', display: 'inline-flex', width: 10, height: 10, flexShrink: 0 }}>
        <span style={{
          position: 'absolute', inset: 0, borderRadius: '50%',
          background: '#22c55e', opacity: 0.6,
          animation: 'ping 1.5s cubic-bezier(0,0,0.2,1) infinite'
        }} />
        <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 8px #22c55e' }} />
      </span>
    );
  }
  return (
    <span style={{ position: 'relative', display: 'inline-flex', width: 10, height: 10, flexShrink: 0 }}>
      <span style={{
        position: 'absolute', inset: 0, borderRadius: '50%',
        background: '#ef4444', opacity: 0.6,
        animation: 'ping 1s cubic-bezier(0,0,0.2,1) infinite'
      }} />
      <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#ef4444', boxShadow: '0 0 8px #ef4444' }} />
    </span>
  );
};

const LiveActivityFeed = ({ clients, assignedWorkouts }) => {
  const [activities, setActivities] = useState(mockActivities);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setPulse(p => !p);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      background: 'rgba(255,255,255,0.04)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 16,
      padding: '20px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span style={{
            width: 8, height: 8, borderRadius: '50%',
            background: '#22c55e',
            boxShadow: '0 0 10px #22c55e',
            display: 'inline-block',
            animation: pulse ? 'none' : undefined,
          }} />
          <h3 style={{
            fontFamily: "'Inter Tight', 'Inter', sans-serif",
            fontWeight: 700,
            fontSize: '0.9rem',
            color: 'rgba(255,255,255,0.9)',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
          }}>
            Live Activity Feed
          </h3>
        </div>
        <span style={{
          fontSize: '0.65rem',
          color: '#22c55e',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
        }}>
          LIVE
        </span>
      </div>
      {/* Feed items */}
      <div className="space-y-2">
        <AnimatePresence>
          {activities?.map((item, i) => (
            <motion.div
              key={item?.id}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.05 }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '8px 10px',
                borderRadius: 8,
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(255,255,255,0.05)',
              }}
            >
              <StatusDot status={item?.status} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.3 }}>
                  <span style={{ fontWeight: 700, color: item?.status === 'active' ? '#22c55e' : '#ef4444' }}>
                    {item?.client}
                  </span>
                  {' '}{item?.action}{' '}
                  <span style={{ color: 'rgba(255,255,255,0.6)' }}>{item?.detail}</span>
                </p>
              </div>
              <span style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.3)', whiteSpace: 'nowrap' }}>
                {item?.time}
              </span>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
      <style>{`
        @keyframes ping {
          75%, 100% { transform: scale(2); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default LiveActivityFeed;
